import _ from 'lodash';
import LogRocket from 'logrocket';
import template from './voiceDownPanel.html';

export default {
  name: 'voiceDownPanel',
  template,
  controllerAs: 'VoiceDownPanelCtrl',
  controller: VoiceDownPanelController,
  bindings: {
    panelId: '<'
  }
};

/* @ngInject */
function VoiceDownPanelController($log, growl, VoiceDownPanelService, DashboardService) {
  const vm = this;

  /**
   * Public Variables
   */
  vm.loadingSpinners = {};
  vm.editPanel = {
    needsToBeConfigured: false
  };
  vm.headerModel = {};
  vm.allEquipmentIds = null;
  vm.voiceDownPanelModel = VoiceDownPanelService.voiceDownPanelModel;
  vm.currentEquipment = null;
  vm.selectedClip = {};

  /**
   * Public Methods
   */
  vm.getClips = getClips;
  vm.playClip = playClip;
  vm.stopClip = stopClip;
  vm.setCurrentEquipment = setCurrentEquipment;
  vm.deleteEquipment = deleteEquipment;

  vm.$onInit = init;
  vm.$onDestroy = destroy;

  function init() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    if (_.has(vm.panel, 'equipment') && vm.panel.equipment.length) {
      vm.editPanel.needsToBeConfigured = false;
      VoiceDownPanelService.putEquipmentsInModel(vm.panel.equipment)
        .then((foundEquipmentIds) => {
          _.forEach(foundEquipmentIds, (equipmentId) => {
            vm.headerModel[equipmentId] = vm.voiceDownPanelModel[equipmentId].equipment;
          });
          vm.allEquipmentIds = foundEquipmentIds;
          setCurrentEquipment(vm.headerModel[vm.allEquipmentIds[0]]);
        });
    } else {
      vm.editPanel.needsToBeConfigured = true;
      vm.loadingSpinners.stopVoiceDown = true;
    }
  }

  function destroy() {
    vm.deleteEquipment(vm.panel.equipment);
  }

  /*
     * Sets currentEquipment and calls getClips
     */
  function setCurrentEquipment(currentEquipment) {
    vm.currentEquipment = currentEquipment.id;
    vm.selectedClip = {};
    vm.getClips(currentEquipment.id);
  }

  /*
     *  Checks if an equipment in the model already has clips.  If not tells voice down service to get it.
     */
  function getClips(equipmentId) {
    vm.loadingSpinners.stopVoiceDown = false;
    if (vm.voiceDownPanelModel[equipmentId]) {
      if (vm.voiceDownPanelModel[equipmentId].clips) {
        // clips already loaded for this equipment
        vm.loadingSpinners.stopVoiceDown = true;
      } else if (!vm.voiceDownPanelModel[equipmentId].clips) {
        VoiceDownPanelService.loadClips(equipmentId)
          .then(() => { vm.alertMsg = _.size(vm.voiceDownPanelModel[equipmentId].clips) > 0 ? '' : 'No clips found' })
          .catch(() => { vm.alertMsg = 'Unable to load clips' })
          .finally(() => { vm.loadingSpinners.stopVoiceDown = true });
      }
    } else {
      $log.error(`equipment does not exist in model:${equipmentId}`);
    }
  }

  /*
     *  Tells service to play specified clip on specified equipment
     */
  function playClip(equipmentId, clipId) {
    let growlMessage;
    if (equipmentId && clipId) {
      // growl playing selected clip true
      growlMessage = growl.info('Connecting to speaker', {
        disableCloseButton: true
      });
      VoiceDownPanelService.playClip(equipmentId, clipId)
        .then(() => {
          growlMessage.destroy();
          growl.success('Clip played');
        })
        .catch((res) => {
          growlMessage.destroy();
          const error = 'Error Playing Clip';
          growl.error(res.error, { title: error });
          LogRocket.track(error);
        });
    } else {
      if (!equipmentId) {
        $log.error('equipment not selected');
      }
      if (!clipId) {
        growl.warning('Clip not selected', {
          ttl: 3000
        });
      }
    }
  }

  /*
     *  Tells service to stop clip
     */
  function stopClip(equipmentId) {
    // growl playing selected clip true
    const growlMessage = growl.info('Connecting to speaker', {
      disableCloseButton: true
    });
    VoiceDownPanelService.stopClip(equipmentId)
      .then(() => {
        if (growlMessage) {
          growlMessage.destroy();
        }
        growl.success('Clip stopped');
      })
      .catch((res) => {
        growlMessage.destroy();
        const error = 'Error Stopping Clip';
        growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }

  function deleteEquipment(equipment) {
    VoiceDownPanelService.deleteEquipment(equipment);
  }

} /** * end of controller * **/
